import { isConnectionBroken } from 'features/settings/logins/utils';
import { BankLoginStatus } from 'reducers/types';
export const BROKEN_LOGIN_STATUS = [
    BankLoginStatus.AccessRevoked,
    BankLoginStatus.WrongCredentials,
    BankLoginStatus.PermanentAccountLock,
    BankLoginStatus.SyncFailed,
    BankLoginStatus.UserInputRequired,
];
export default (data, brokenConnections) => {
    const renew_access = [];
    const open_banking = [];
    const ready_and_anythingelse = [];
    for (let index = 0; index < data.length; index++) {
        const connection = data[index];
        if (isConnectionBroken(connection)) {
            renew_access.push(connection);
        }
        else if (connection.consentExpiresAt) {
            open_banking.push(connection);
        }
        else {
            ready_and_anythingelse.push(connection);
        }
    }
    if (brokenConnections) {
        return renew_access;
    }
    return renew_access.concat(open_banking).concat(ready_and_anythingelse);
};
